import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AllAgents.css';
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";
import SalespersonSidebar from "./SalespersonSidebar";

const SportSpecificAgent = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const {sport} = useParams();
    const [activeAgents, setActiveAgents] = useState([]);
    const [title, setTitle] = useState([]);
    const location = useLocation();
    const path = location.pathname;

    const AllUSMap = path === ('/sports_scouts_usmap/all');

    let sports = "";

    if (path.includes("baseball")) sports = "Baseball";
    if (path.includes("basketball")) sports = "Basketball";
    if (path.includes("football")) sports = "Football"; 
    if (path.includes("hockey")) sports = "Hockey";
    if (path.includes("rugby")) sports = "Rugby"; 
    if (path.includes("soccer")) sports = "Soccer";
    if (path.includes("cricket")) sports = "Cricket";

    useEffect(() => {
        const staticData = [
            {   
                id: "1", 
                name: 'Matthew Judd',
                // image: '/images/Test_grid_1000x1000.png',
                address:'Toronto, Alabama, <br />US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Baseball',
            },
            {   
                id: "2", 
                name: 'Ambia Mari Abolucion',
                // image: '/images/Test_grid_1000x1000.png',
                address:'Chelsea, Alabama, <br />US',
                url:'',
                // continent:{value:'7', label:'North America'},
                sport: 'Basketball',
            },
            {   
                id: "3", 
                name: 'Ashok Anjara',
                // image: '/images/Test_grid_1000x1000.png',
                address:'Phoenix, Arizona, <br />US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Football',
            },
            {   
                id: "4", 
                name: 'Ashok Anjara',
                image: '',
                address:',California,<br />US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Football (American)',
            },
            {   
                id: "5", 
                name: 'Matthew Judd',
                image: '/images/Test_grid_1000x1000.png',
                address:'Toronto, Alabama, <br />US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Baseball',
            },
            {   
                id: "6", 
                name: 'Ambia Mari Abolucion',
                image: '/images/Test_grid_1000x1000.png',
                address:'Chelsea, Alabama, <br />US',
                url:'',
                // continent:{value:'7', label:'North America'},
                sport: 'Basketball',
            },
            {   
                id: "7", 
                name: 'Ashok Anjara',
                image: '/images/Test_grid_1000x1000.png',
                address:'Phoenix, Arizona, <br />US',
                url:'',
                // continent:{value:'4', label:'Asia'},
                sport: 'Football',
            }
        ];
        //setActiveAgents(staticData);
    },[]);

        //pagination
        const [currentPage, setCurrentPage] = useState(1);
        const [itemsPerPage, setItemsPerPage] = useState(50);
    
            const startIndex =
                (currentPage - 1) * itemsPerPage;
            const endIndex =
                startIndex + itemsPerPage;
            const currentItems =
                activeAgents.slice(startIndex, endIndex);
    
        function goToNextPage() {
            setCurrentPage(prevPage => prevPage + 1);
        }
    
        function goToPrevPage() {
            setCurrentPage(prevPage => prevPage - 1);
        }
    
        function goToSpecificPage(pageNumber) {
            setCurrentPage(pageNumber);
        }
        function renderPaginationControls() {
            const totalPages = Math.ceil(activeAgents.length / itemsPerPage);

            const goToFirstPage = () => setCurrentPage(1);
            const goToLastPage = () => setCurrentPage(totalPages);

            const maxButtons = 10;
            let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
            let endPage = startPage + maxButtons - 1;

            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(1, endPage - maxButtons + 1);
            }

            const pageNumbers = [];
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }

            return (
                <div>
                    {activeAgents.length > itemsPerPage && (
                        <div style={{ textAlign: "center" }} className="all-agent-list-pagination">

                            {/* First + Prev */}
                            {currentPage !== 1 && (
                                <>
                                    <button onClick={goToFirstPage}>« First</button>
                                    <button onClick={goToPrevPage}>‹ Previous</button>
                                </>
                            )}
                            {pageNumbers.map((num) => (
                                <button
                                    key={num}
                                    onClick={() => goToSpecificPage(num)}
                                    style={{
                                        fontWeight: num === currentPage ? "bold" : "normal",
                                        color: num === currentPage ? "#111" : "#2c99d2",
                                    }}
                                >
                                    {num}
                                </button>
                            ))}

                            {/* Next + Last */}
                            {currentPage !== totalPages && (
                                <>
                                    <button onClick={goToNextPage}>Next ›</button>
                                    <button onClick={goToLastPage}>Last »</button>
                                </>
                            )}
                        </div>
                    )}
                </div>
            );
        }
        const lastPageIndex = Math.min(activeAgents.length, endIndex);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
        setIsLoading(false);
        })
     
    },[]);

    React.useEffect(() => {
         const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
            try {
               setIsLoading(true);
            const response = await fetch(app_url+'smwwagency/getsportsagentlist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
               page: currentPage,
            pagesize: itemsPerPage,
            sport:sport
            // id:continentid
              }),
            });
            const data = await response.json();
            setActiveAgents(data.data.result);
            setTitle(data.data.title);
          }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
          };
      
          fetchData();
         
    }, [currentPage]); // Re-fetch data when these change

    return (
        <>      
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main" className="sport-specific-agents-main">
                    <Helmet><title>{title}</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="all-agent-container">
                            {activeAgents.length === 0 ? (<p><b>No Agents found for your criteria, please try another search.</b></p>) : (
                                <div>
                                    <h1>{title}</h1>
                                    <div className="all-agent-list-container">
                                        <ul>
                                            {currentItems.map((agent, index) => (
                                            <li key={index}>  
                                                <div className="">
                                                    <a href={agent.url}  target="_blank" rel="noreferrer">
                                                        {((agent.image === '') || !agent.image )? (
                                                            <img
                                                                src='/basic/web/images/agency_logo.png'
                                                                alt={agent.name}
                                                                style={{maxWidth: "100px", maxHeight: "100px"}}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={agent.image}
                                                                alt={agent.name}
                                                                style={{maxWidth: "100px", maxHeight: "100px"}}
                                                            />
                                                        )}
                                                    </a>
                                                </div> 

                                                <div className="">
                                                    <a href={agent.url}  target="_blank" rel="noreferrer">{agent.name}</a>
                                                </div>
                                                <div><div dangerouslySetInnerHTML={{ __html: agent.address }} /></div>
                                            </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div style={{clear: "both"}}></div>
                                    {renderPaginationControls()}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="right">
                        <div className="agent-block sport-specific-agent-block-1">
                            <AgencySidebar />
                        </div>
                        <div className="agent-block sport-specific-agent-block-2">
                            <h2>Our Agents Make The Difference</h2>
                            <div className="">
                                <p>
                                    Professional athletes have important decisions to make regarding everything from choosing their team to choosing their life insurance plan.
                                    It is our aim to help the athlete through some of these difficult choices by keeping the lines of communication open, educating them on their options, and being a center of support for them in every aspect of their lives and careers.
                                </p>
                                <p>
                                    As a global sports agency, we offer our clients an array of services including financial, contract negotiation, personal consulting, sponsorships, and marketing.
                                    Add that to the one-on-one daily guidance our Agent Advisors provide and our clients are destined for success - both on and off the field.
                                    This combination gives clients a boutique agency level of attention, as well as the benefits of a powerful, high efficiency, full-service super agency.
                                </p>
                                <p>
                                    Sports Management Worldwide is here to guide you and help you make an informed decision that supports what is most important for your individual career.
                                    From contract negotiation to product endorsements, to travel arrangements, to athletic training, Sports Management Worldwide wants to be a step ahead of you and assist you with all your important decisions.
                                </p>
                                <p>
                                    A professional career can be short or long; either way, SMWW wants to help you make it as successful as possible and help an athlete prepare for their life after sports.
                                </p>
                            </div>
                        </div>
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default SportSpecificAgent;